import React, { useEffect, useState } from 'react'
import { Container } from '../../common/layout/styels';
import CrudForm from '../../../elements/list/create';
import { useTranslation } from 'react-i18next';
import Layout from "../../common/layout";
import { useSelector } from 'react-redux';

const BulkUploadUser = (props) => {
    const { t } = useTranslation();
    const user = useSelector((state)=> state.login)

    useEffect(() => {
        document.title = `${t("bulkUpload")} - PersoBase`;
      }, [t]);

    const [attributes] = useState([
        {
          type: "select",
          placeholder: "sortBy",
          name: "sortBy",
          validation: "",
          tab: "generalInfo",
          default: "personalNumber",
          label: "sortBy",
          required: false,
          filter: true,
          view: false,
          add: false,
          update: false,
          filterType: "select",
          apiType: "JSON",
          selectApi: [
            { id: "firstName", value: `${t("firstName")}` },
            { id: "lastName", value: `${t("lastName")}` },
            { id: "personalNumber", value: `${t("personnelNumber")}` },
          ],
        },
        {
          type: "select",
          placeholder: "sortType",
          name: "sortType",
          validation: "",
          default: "",
          label: "sortType",
          tab: "generalInfo",
          required: false,
          filter: true,
          view: false,
          add: false,
          update: false,
          filterType: "select",
          apiType: "JSON",
          selectApi: [
            { id: "-1", value: `${t("descending")}` },
            { id: "1", value: `${t("ascending")}` },
          ],
        },
        {
          type: "number",
          placeholder: "personalNumber",
          name: "personalNumber",
          tab: "generalInfo",
          validation: "",
          default: user?.data?.highestPersonnelNumber,
          label: "personalNumber",
          required: false,
          view: true,
          add: true,
          update: true,
        },
        {
          type: "select",
          placeholder: "title",
          name: "academicTitle",
          tab: "generalInfo",
          validation: "",
          default: "",
          label: "academicTitle",
          required: false,
          view: false,
          filter: false,
          tag: true,
          add: true,
          update: true,
          apiType: "CSV",
          selectApi: "Prof.,Dr.",
        },
        {
          type: "text",
          placeholder: "--",
          name: "fullName",
          tab: "generalInfo",
          validation: "textonly",
          default: "",
          label: "fullName",
          required: false,
          view: true,
          add: false,
          update: false,
        },
        {
          type: "text",
          placeholder: "firstName",
          name: "firstName",
          tab: "generalInfo",
          validation: "textonly",
          default: "",
          label: "firstName",
          required: true,
          upload: true,
          view: false,
          add: true,
          update: true,
        },
        {
          type: "text",
          placeholder: "lastName",
          name: "lastName",
          tab: "generalInfo",
          validation: "textonly",
          default: "",
          label: "lastName",
          required: true,
          upload: true,
          view: false,
          add: true,
          update: true,
        },
        {
          type: "text",
          placeholder: "birthName",
          name: "birthName",
          tab: "generalInfo",
          validation: "",
          default: "",
          label: "birthName",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "text",
          placeholder: "enterNumber",
          name: "mobileNumber",
          tab: "generalInfo",
          validation: "mobile",
          default: "",
          label: "mobileNumber",
          required: false,
          upload: true,
          view: true,
          add: true,
          update: true,
        },
        {
          type: "text",
          placeholder: "enterEmail",
          tab: "generalInfo",
          name: "email",
          validation: "email",
          default: "",
          label: "email",
          required: false,
          upload: true,
          view: true,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "select",
          placeholder: "select",
          name: "location",
          tab: "generalInfo",
          validation: "",
          showItem: "title",
          default: "",
          label: "location",
          required: true,
          filter: false,
          view: false,
          upload: true,
          tag: true,
          add: true,
          update: true,
          apiType: "API",
          selectApi: "location/select",
        },
        {
          type: "select",
          placeholder: "select",
          name: "department",
          tab: "generalInfo",
          validation: "",
          showItem: "title",
          default: "",
          label: "department",
          required: true,
          filterType: "multiSelect",
          view: true,
          upload: true,
          tag: true,
          add: true,
          update: true,
          apiType: "API",
          selectApi: "department/select",
        },
        {
          type: "select",
          placeholder: "select",
          name: "designation",
          updateOn: "department",
          tab: "generalInfo",
          validation: "",
          showItem: "title",
          default: "",
          label: "designation",
          required: false,
          filterType: "multiSelect",
          filter: false,
          view: false,
          tag: true,
          add: true,
          update: true,
          apiType: "API",
          selectApi: "designation/select",
        },
        {
          type: "select",
          placeholder: "select",
          tab: "generalInfo",
          name: "shiftTemplate",
          validation: "",
          default: "",
          label: "dshift",
          showItem: "title",
          required: true,
          filter: false,
          view: false,
          upload: true,
          tag: true,
          add: true,
          update: true,
          apiType: "API",
          selectApi: "shift/select",
        },
        {
          type: "multiSelect",
          placeholder: "select",
          tab: "generalInfo",
          name: "place",
          validation: "",
          showItem: "title",
          default: "",
          label: "place",
          required: true,
          filterType: "multiSelect",
          view: true,
          upload: true,
          tag: true,
          add: true,
          update: true,
          apiType: "API",
          selectApi: "place/select",
        },
        {
          type: "select",
          placeholder: "select",
          name: "userType",
          tab: "generalInfo",
          validation: "",
          showItem: "title",
          default: "",
          label: "userType",
          required: true,
          filter: false,
          upload: true,
          view: false,
          tag: true,
          add: true,
          update: true,
          apiType: "API",
          selectApi: "user-type/select",
        },
        {
          type: "checkbox",
          placeholder: "acceptLogin",
          tab: "generalInfo",
          name: "acceptLogin",
          validation: "",
          showItem: "",
          default: "",
          label: "acceptLogin",
          required: false,
          view: false,
          tag: true,
          add: false,
          update: false,
        },
        {
          type: "expired",
          placeholder: "status",
          tab: "generalInfo",
          name: "contractEnd",
          validation: "",
          collection: "",
          showItem: "contractEnd",
          default: "",
          value: "Active",
          ifNull: "Inactive",
          label: "status",
          required: false,
          view: true,
          tag: true,
          add: false,
          update: true,
        },
        {
          type: "select",
          placeholder: "status",
          tab: "generalInfo",
          name: "status",
          validation: "",
          collection: "",
          default: "",
          label: "status",
          required: false,
          view: false,
          tag: false,
          add: false,
          update: true,
          filter: false,
          apiType: "JSON",
          selectApi:[
            {id: "Active", value: t("active")},
            {id: "Inactive", value: t("inactive")}
          ]
        },
        {
          type: "invitation",
          placeholder: "invitation",
          tab: "generalInfo",
          name: "invitationSent",
          validation: "",
          showItem: "invitation",
          default: "",
          label: "invitation",
          required: false,
          view: false,
          tag: true,
          add: false,
          update: false,
        },
        {
          type: "select",
          placeholder: "select",
          name: "costCenter",
          tab: "generalInfo",
          validation: "",
          showItem: "locale",
          default: "",
          label: "costCenter",
          required: false,
          filter: false,
          view: false,
          tag: true,
          add: true,
          update: true,
          apiType: "API",
          selectApi: "cost-center/select",
        },
        // {
        //   type: "text",
        //   placeholder: "addedBy",
        //   tab: "generalInfo",
        //   name: "addedBy",
        //   validation: "",
        //   showItem: "fullName",
        //   collection: "addedBy",
        //   default: "",
        //   label: "addedBy",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: false,
        //   update: false,
        // },
        //genral info end
        //personal info starts
        {
          type: "text",
          placeholder: "enterStreetNumber",
          name: "streetNumber",
          tab: "personalData",
          validation: "",
          default: "",
          label: "streetNumber",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "text",
          placeholder: "enterPostalCode",
          name: "postalCode",
          tab: "personalData",
          validation: "",
          default: "",
          label: "postalCode",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "text",
          placeholder: "enterCity",
          name: "city",
          tab: "personalData",
          validation: "",
          default: "",
          label: "city",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "select",
          placeholder: "select",
          name: "gender",
          tab: "personalData",
          validation: "",
          default: "",
          label: "gender",
          required: false,
          view: false,
          filter: false,
          tag: true,
          add: true,
          update: true,
          apiType: "JSON",
          selectApi: [
            { id: "Male", value: t("Male") },
            { id: "Female", value: t("Female") },
            { id: "Diverse", value: t("Diverse") },
          ],
        },
        {
          type: "date",
          placeholder: "selectBirthDate",
          name: "birthDate",
          tab: "personalData",
          validation: "date",
          default: "empty",
          label: "birthDate",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "select",
          apiType: "API",
          selectApi: "user/nationalities",
          placeholder: "select",
          name: "nationality",
          filter: false,
          tab: "personalData",
          validation: "",
          showItem: "locale",
          default: "",
          label: "nationality",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
          search: true
        },
        {
          type: "text",
          placeholder: "enterCityOfBirth",
          name: "cityOfBirth",
          tab: "personalData",
          validation: "",
          default: "",
          label: "cityOfBirth",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "select",
          apiType: "API",
          selectApi: "user/countries",
          showItem: "locale",
          placeholder: "select",
          name: "countryOfBirth",
          tab: "personalData",
          validation: "",
          default: "",
          label: "countryOfBirth",
          required: false,
          filter: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "select",
          placeholder: "select",
          name: "maritalStatus",
          tab: "personalData",
          filter: false,
          validation: "",
          default: "",
          label: "maritalStatus",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
          apiType: "JSON",
          selectApi: [
            { id: "single", value: t("single") },
            { id: "married", value: t("married") },
            { id: "divorced", value: t("divorced") },
            { id: "widowed", value: t("widowed") },
            { id: "permanentlySeparated", value: t("permanentlySeparated") },
          ],
        },
        // {
        //   type: "select",
        //   apiType: "JSON",
        //   selectApi: [
        //     { id: "Yes", value: t("Yes") },
        //     { id: "No", value: t("No") },
        //   ],
        //   placeholder: "severelyDisabled",
        //   name: "severelyDisabled",
        //   tab: "personalData",
        //   filter: false,
        //   validation: "",
        //   default: "",
        //   label: "severelyDisabled",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        // {
        //   type: "title",
        //   tab: "personalData",
        //   title: "School Graduation / Occupation Training",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        // {
        //   type: "select",
        //   placeholder: "highestSchoolDegree",
        //   name: "highestSchoolDegree",
        //   tab: "personalData",
        //   filter: false,
        //   validation: "",
        //   default: "",
        //   label: "highestSchoolDegree",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        //   apiType: "JSON",
        //   selectApi: [
        //     { id: "No school degree", value: t("No school degree") },
        //     { id: "Primary/Elementary School", value: t("Primary/Elementary School") },
        //     { id: "Intermediate School Certificate or Equivalent", value: t("Intermediate School Certificate or Equivalent") },
        //     { id: "High School Diploma/University Entrance Qualification", value: t("High School Diploma/University Entrance Qualification") },
        //   ],
        // },
        // {
        //   type: "select",
        //   placeholder: "highestProfessionalTraining",
        //   name: "highestProfessionalTraining",
        //   tab: "personalData",
        //   filter: false,
        //   validation: "",
        //   default: "",
        //   label: "highestProfessionalTraining",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        //   apiType: "JSON",
        //   selectApi: [
        //     { id: "No professional training certificate", value: t("No professional training certificate") },
        //     { id: "Recognized Vocational Training", value: t("Recognized Vocational Training") },
        //     { id: "Master/Technician or Equivalent", value: t("Master/Technician or Equivalent") },
        //     { id: "Bachelor's Degree", value: t("Bachelor's Degree") },
        //     { id: "Diploma/Master's Degree", value: t("Diplom/Magister/Master/Staatsexamen") },
        //   ],
        // },
        //bank details
        {
          type: "text",
          tab: "bankingInformation",
          placeholder: "enterIban",
          name: "iban",
          validation: "iban",
          default: "",
          label: "iban",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "text",
          placeholder: "enterBic",
          tab: "bankingInformation",
          name: "bic",
          validation: "",
          default: "",
          label: "bic",
          maximum: 12,
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "text",
          placeholder: "enterBank",
          tab: "bankingInformation",
          name: "bank",
          validation: "textonly",
          default: "",
          label: "bank",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "text",
          placeholder: "enterAccountHolder",
          tab: "bankingInformation",
          name: "accountHolder",
          validation: "",
          default: "",
          label: "accountHolder",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        // pbacnk details over
        //social secutity and tax
        // {
        //   type: "select",
        //   placeholder: "maritalStatus",
        //   name: "maritalStatus",
        //   tab: "socialInsurance",
        //   filter: false,
        //   validation: "",
        //   default: "",
        //   label: "maritalStatus",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        //   apiType: "JSON",
        //   selectApi: [
        //     { id: "single", value: t("single") },
        //     { id: "married", value: t("married") },
        //     { id: "divorced", value: t("divorced") },
        //     { id: "widowed", value: t("widowed") },
        //     { id: "permanentlySeparated", value: t("permanentlySeparated") },
        //   ],
        // },
        {
          type: "title",
          tab: "socialInsurance",
          title: "socialSecurityData",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        // {
        //   type: "select",
        //   placeholder: "insuranceStatus",
        //   name: "insuranceStatus",
        //   tab: "socialInsurance",
        //   validation: "",
        //   filter: false,
        //   default: "",
        //   label: "insuranceStatus",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        //   apiType: "JSON",
        //   selectApi: [
        //     { id: "Statutory", value: t("Statutory") },
        //     { id: "Private", value: t("Private") },
        //     { id: "Unspecified", value: t("Unspecified") },
        //   ],
        // },
        {
          type: "text",
          placeholder: "enterSocialSecurityNumber",
          name: "socialSecurityNumber",
          tab: "socialInsurance",
          validation: "svnumber",
          default: "",
          label: "socialSecurityNumber",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "select",
          apiType: "API",
          selectApi: "user/insurance",
          showItem: "title",
          placeholder: "select",
          name: "healthInsurance",
          tab: "socialInsurance",
          validation: "",
          default: "",
          filter: false,
          label: "healthInsurance",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "select",
          placeholder: "select",
          name: "highestSchoolDegree",
          tab: "socialInsurance",
          filter: false,
          validation: "",
          default: "",
          label: "highestSchoolDegree",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
          apiType: "JSON",
          selectApi: [
            { id: "No school degree", value: t("No school degree") },
            { id: "Primary/Elementary School", value: t("Primary/Elementary School") },
            { id: "Intermediate School Certificate or Equivalent", value: t("Intermediate School Certificate or Equivalent") },
            { id: "High School Diploma/University Entrance Qualification", value: t("High School Diploma/University Entrance Qualification") },
          ],
        },
        {
          type: "select",
          placeholder: "select",
          name: "highestProfessionalTraining",
          tab: "socialInsurance",
          filter: false,
          validation: "",
          default: "",
          label: "highestProfessionalTraining",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
          apiType: "JSON",
          selectApi: [
            { id: "No professional training certificate", value: t("No professional training certificate") },
            { id: "Recognized Vocational Training", value: t("Recognized Vocational Training") },
            { id: "Master/Technician or Equivalent", value: t("Master/Technician or Equivalent") },
            { id: "Bachelor's Degree", value: t("Bachelor's Degree") },
            { id: "Diploma/Master's Degree", value: t("Diplom/Magister/Master/Staatsexamen") },
          ],
        },
        {
          type: "select",
          placeholder: "select",
          tab: "socialInsurance",
          name: "employmentType",
          validation: "",
          default: "",
          label: "employmentType",
          required: false,
          filterType: "multiSelect",
          view: false,
          tag: true,
          add: true,
          update: true,
          apiType: "JSON",
          selectApi: [
            { id: "permanentEmployment", value: t("permanentEmployment") },
            { id: "shortTermEmployment", value: t("shortTermEmployment") },
            { id: "miniJob", value: t("miniJob") },
            { id: "studentWorker", value: t("studentWorker") },
            { id: "internship", value: t("internship") },
          ],
        },
        {
          type: "select",
          placeholder: "select",
          tab: "socialInsurance",
          name: "temporaryEmployment",
          validation: "",
          default: "",
          label: "temporaryEmployment",
          required: false,
          filter: false,
          view: false,
          tag: true,
          add: true,
          update: true,
          apiType: "JSON",
          selectApi: [
            { id: "yes", value: t("yes") },
            { id: "no", value: t("no") },
          ],
        },
        {
          type: "title",
          tab: "socialInsurance",
          title: "taxData",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "number",
          placeholder: "enterTaxID",
          name: "taxID",
          tab: "socialInsurance",
          validation: "",
          default: "",
          label: "taxID",
          minimum: 12,
          maximum: 12,
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
    
        {
          type: "select",
          placeholder: "select",
          name: "taxClass",
          tab: "socialInsurance",
          validation: "",
          default: "",
          label: "taxClass",
          filter: false,
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
          apiType: "JSON",
          selectApi: [
            { id: "one", value: t("one") },
            { id: "two", value: t("two") },
            { id: "three", value: t("three") },
            { id: "four", value: t("four") },
            { id: "five", value: t("five") },
            { id: "six", value: t("six") },
            { id: "doubleTaxationAgreement", value: t("doubleTaxationAgreement") },
          ],
        },
        {
          type: "select",
          placeholder: "select",
          name: "religion",
          tab: "socialInsurance",
          showItem: "locale",
          filter: false,
          validation: "",
          default: "",
          label: "religion",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
          apiType: "API",
          selectApi: "religion/select",
        },
        {
          type: "select",
          apiType: "JSON",
          selectApi: [
            { id: "Yes", value: t("Yes") },
            { id: "No", value: t("No") },
          ],
          placeholder: "select",
          name: "severelyDisabled",
          tab: "socialInsurance",
          filter: false,
          validation: "",
          default: "",
          label: "severelyDisabled",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        // {
        //   type: "number",
        //   placeholder: "bavMonthly",
        //   name: "bavMonthly",
        //   tab: "socialInsurance",
        //   validation: "number",
        //   default: "0",
        //   label: "bavMonthly",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        {
          type: "number",
          placeholder: "EnterChildAllowance",
          name: "childAllowance",
          tab: "socialInsurance",
          validation: "",
          default: "",
          label: "childAllowance",
          filter: false,
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        // {
        //   type: "number",
        //   placeholder: "monthlyAllowance",
        //   name: "monthlyAllowance",
        //   tab: "socialInsurance",
        //   validation: "",
        //   default: "",
        //   label: "monthlyAllowance",
        //   filter: false,
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        //socialInsurance end
        {
          type: "select",
          placeholder: "status",
          name: "status",
          tab: "socialInsurance",
          validation: "",
          default: "active",
          value: "active",
          label: "status",
          required: false,
          filterType: "select",
          view: false,
          tag: false,
          add: false,
          update: false,
          filter: true,
          apiType: "JSON",
          selectApi: [
            { id: "active", value: t("active") },
            { id: "inactive", value: t("inactive") },
            { id: "all", value: t("all") },
          ],
        },
        //employment info starts
        {
          type: "title",
          tab: "official",
          title: "contract",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "date",
          placeholder: "selectDate",
          tab: "official",
          name: "contractFrom",
          validation: "date",
          default: "empty",
          label: "contractFrom",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "date",
          placeholder: "selectDate",
          name: "contractEnd",
          tab: "official",
          validation: "date",
          default: "empty",
          label: "contractEnd",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        // {
        //   type: "select",
        //   placeholder: "employmentType",
        //   tab: "official",
        //   name: "employmentType",
        //   validation: "",
        //   default: "",
        //   label: "employmentType",
        //   required: false,
        //   filterType: "multiSelect",
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        //   apiType: "JSON",
        //   selectApi: [
        //     { id: "permanentEmployment", value: t("permanentEmployment") },
        //     { id: "shortTermEmployment", value: t("shortTermEmployment") },
        //     { id: "miniJob", value: t("miniJob") },
        //     { id: "studentWorker", value: t("studentWorker") },
        //     { id: "internship", value: t("internship") },
        //   ],
        // },
    
        // {
        //   type: "number",
        //   placeholder: "monthlyIncome",
        //   name: "monthlyIncome",
        //   tab: "official",
        //   validation: "number",
        //   default: "0",
        //   label: "monthlyIncome",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        // {
        //   type: "number",
        //   placeholder: "hourlyWages",
        //   name: "hourlyWages",
        //   tab: "official",
        //   validation: "number",
        //   default: "0",
        //   label: "hourlyWages",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        // {
        //   type: "number",
        //   placeholder: "allowanceMonth",
        //   name: "allowanceMonth",
        //   tab: "official",
        //   validation: "number",
        //   default: "0",
        //   label: "allowanceMonth",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        // {
        //   type: "number",
        //   placeholder: "allowanceYear",
        //   name: "allowanceYear",
        //   tab: "official",
        //   validation: "number",
        //   default: "0",
        //   label: "allowanceYear",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        //vacation
        {
          type: "title",
          tab: "official",
          title: "vacation",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "number",
          placeholder: "enterDays",
          name: "vacationPerYear",
          tab: "official",
          validation: "number",
          default: "0",
          label: "vacationPerYear",
          required: false,
          view: false,
          tag: true,
          add: false,
          update: true,
        },
    
        {
          type: "number",
          placeholder: "enterDays",
          name: "vacationRemaining",
          tab: "official",
          validation: "number",
          default: "0",
          label: "vacationRemaining",
          required: true,
          view: false,
          tag: true,
          add: false,
          update: false,
        },
        // {
        //   type: "number",
        //   placeholder: "hourlyWages",
        //   name: "hourlyWages",
        //   tab: "official",
        //   validation: "number",
        //   default: "0",
        //   label: "hourlyWages",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        {
          type: "number",
          placeholder: "enterDays",
          name: "vacationFromLastYear",
          tab: "official",
          validation: "number",
          default: "0",
          label: "vacationFromLastYear",
          required: false,
          view: false,
          tag: true,
          add: false,
          update: true,
        },
        // {
        //   type: "number",
        //   placeholder: "otherPaymentsMonthly",
        //   name: "otherPaymentsMonthly",
        //   tab: "official",
        //   validation: "number",
        //   default: "0",
        //   label: "otherPaymentsMonthly",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        //Hourly quota
        {
          type: "title",
          tab: "official",
          title: "Hourly quota",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "number",
          placeholder: "enterHours",
          name: "hoursAtLeast",
          tab: "official",
          validation: "",
          default: "",
          label: "Hours At least",
          required: false,
          tag: true,
          view: false,
          add: true,
          update: true,
        },
        {
          type: "number",
          placeholder: "enterHours",
          name: "hoursMaximum",
          tab: "official",
          validation: "",
          default: "",
          label: "Hours Maximum",
          required: false,
          tag: true,
          view: false,
          add: true,
          update: true,
        },
        {
          type: "number",
          placeholder: "enterHours",
          name: "hoursTarget",
          tab: "official",
          validation: "",
          default: "",
          label: "Hours target",
          required: false,
          tag: true,
          view: false,
          add: true,
          update: true,
        },
    
        //Termination
        {
          type: "title",
          tab: "official",
          title: "termination",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "date",
          placeholder: "selectDate",
          name: "terminationDate",
          tab: "official",
          validation: "",
          default: "empty",
          label: "terminationDate",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "view",
          placeholder: "terminationBy",
          name: "terminationBy",
          tab: "official",
          validation: "",
          default: "",
          collection: "terminationBy",
          label: "terminationBy",
          required: false,
          tag: true,
          view: false,
          add: false,
          update: false,
        },
        {
          type: "number",
          placeholder: "enterDays",
          name: "noticePeriod",
          tab: "official",
          validation: "",
          default: "",
          label: "noticePeriod",
          required: false,
          tag: true,
          view: false,
          add: true,
          update: true,
        },
        {
          type: "date",
          placeholder: "selectDate",
          name: "exitDate",
          tab: "official",
          validation: "",
          default: "empty",
          label: "Notice of termination received",
          required: false,
          tag: true,
          view: false,
          add: true,
          update: true,
        },
        // {
        //   type: "text",
        //   placeholder: "cancellationGet",
        //   name: "cancellationGet",
        //   tab: "official",
        //   validation: "",
        //   default: "",
        //   label: "cancellationGet",
        //   required: false,
        //   tag: true,
        //   view: false,
        //   add: true,
        //   update: true,
        // },
        {
          type: "text",
          placeholder: "terminationReason",
          name: "terminationReason",
          tab: "official",
          validation: "",
          default: "",
          label: "terminationReason",
          required: false,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        // {
        //   type: "text",
        //   placeholder: "terminationType",
        //   name: "terminationType",
        //   tab: "official",
        //   validation: "",
        //   default: "",
        //   label: "terminationType",
        //   required: false,
        //   view: false,
        //   tag: true,
        //   add: true,
        //   update: true,
        // },
        {
          type: "date",
          placeholder: "selectDate",
          name: "lastWorkingDay",
          tab: "official",
          validation: "",
          default: "empty",
          label: "lastWorkingDay",
          required: false,
          tag: true,
          view: false,
          add: true,
          update: true,
        },
        {
          type: "image",
          placeholder: "photo",
          name: "photo",
          tab: "generalInfo",
          validation: "",
          default: "",
          label: "photo",
          required: false,
          view: false,
          tag: false,
          add: true,
          update: true,
        },
        {
          type: "checkbox",
          placeholder: "Monday",
          name: "mon",
          tab: "workDays & timeRecording",
          validation: "",
          showItem: "",
          default: "true",
          label: "Monday",
          required: true,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "checkbox",
          placeholder: "Tuesday",
          name: "tue",
          tab: "workDays & timeRecording",
          validation: "",
          showItem: "",
          default: "true",
          label: "Tuesday",
          required: true,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "checkbox",
          placeholder: "Wednesday",
          name: "wed",
          tab: "workDays & timeRecording",
          validation: "",
          showItem: "",
          default: "true",
          label: "Wednesday",
          required: true,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "checkbox",
          placeholder: "Thursday",
          name: "thu",
          tab: "workDays & timeRecording",
          validation: "",
          showItem: "",
          default: "true",
          label: "Thursday",
          required: true,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "checkbox",
          placeholder: "Friday",
          name: "fri",
          tab: "workDays & timeRecording",
          validation: "",
          showItem: "",
          default: "true",
          label: "Friday",
          required: true,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "checkbox",
          placeholder: "Saturday",
          name: "sat",
          tab: "workDays & timeRecording",
          validation: "",
          showItem: "",
          default: "true",
          label: "Saturday",
          required: true,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "checkbox",
          placeholder: "Sunday",
          name: "sun",
          tab: "workDays & timeRecording",
          validation: "",
          showItem: "",
          default: "true",
          label: "Sunday",
          required: true,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "checkbox",
          placeholder: "Time recording when shift in Roster",
          name: "timeRecordWithShiftRoaster",
          tab: "workDays & timeRecording",
          validation: "",
          showItem: "",
          default: "true",
          condition: { item: "companyRoster", if: true, then: "enabled", else: "disabled" },
          label: "Time recording when shift in Roster",
          required: true,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
        {
          type: "checkbox",
          placeholder: "Time recording without Roster",
          name: "timeRecordWithoutRoaster",
          tab: "workDays & timeRecording",
          condition: { item: "companyRoster", if: true, then: "enabled", else: "disabled" },
          validation: "",
          showItem: "",
          default: "false",
          label: "Time recording without Roster",
          required: true,
          view: false,
          tag: true,
          add: true,
          update: true,
        },
      ]);

    return (
        <Container className="noshadow">
            <CrudForm
          bulkUpload={true}
          delPrivilege={false}
          setMessage={props.setMessage}
          setLoaderBox={props.setLoaderBox}
          formMode={"single"}
          formView={"page"}
          api={`user`}
          formType={"put"}
          updateId={""}
          header={t("bulkUpload")}
          formInput={attributes}
          formErrors={[]}
          formValues={[]}
          currentApi={`user`}
          submitHandler={() => {}}
          isOpenHandler={() => {}}
          isOpen={true}
          plainForm="plain"
        ></CrudForm>
          {/* <ListTable {...props} viewDetails={false} actions={actions} api={`leave-request`} itemTitle={`fullName`} shortName={`leaveRequest`} addPrivilege={false} delPrivilege={false} updatePrivilege={false} attributes={attributes} listHeadClass={"static"} ></ListTable>
          {action.data && (
            <PopupView
              themeColors={themeColors}
              openData={action}
              itemTitle={{ name: "fullName", collection: "user" }}
              popupData={
                <ApproveLeave
                  closeModal={() => {
                    action.refreshView();
                    setActions([]);
                  }}
                  setLoaderBox={props.setLoaderBox}
                  setMessage={props.setMessage}
                  openData={action}
                />
              }
              closeModal={() => {
                setActions([]);
              }}
            ></PopupView>
          )} */}
        </Container>
      );
    };

export default Layout(BulkUploadUser);